import { createRoot } from "react-dom/client";

import App from "./App";

import "@react95/core/GlobalStyle";

import "@react95/core/themes/win95.css";

import "./index.css";

import "./reset.css";

import "./Clippy.css";

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);
